import React, { useState } from 'react';
import _ from 'lodash';
import { styled } from '@this/constants/themes';
import { observer } from 'mobx-react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import type Calendar from '@this/domain/appoint/calendar';
import { Box, TextField, Tooltip, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import muiTheme from '@this/components/appoint/mui_theme';

interface Props {
  participants: Calendar[];
  calendars: Calendar[];
  onAdd: (p: Calendar) => void;
  onRemove: (p: Calendar) => void;
  inputStyle?: React.CSSProperties;
}

const ParticipantInput = observer(({ participants, calendars, onAdd, onRemove, inputStyle }: Props) => {
  const [addParticipantText, setAddParticipantText] = useState<string>('');
  return (
    <>
      <Autocomplete
        options={calendars}
        renderOption={option => (
          <ParticipantOption>
            <ParticipantIcon />
            <div>
              <ParticipantMainText>{option.name}</ParticipantMainText>
              <ParticipantSubText>{option.id}</ParticipantSubText>
            </div>
          </ParticipantOption>
        )}
        inputValue={addParticipantText}
        filterOptions={(options, state) => {
          const q = state.inputValue;
          return options.filter(
            o => (o.id.indexOf(q) > -1 || o.name.indexOf(q) > -1) && participants.indexOf(o) === -1
          );
        }}
        onInputChange={(_event, value, reason) => {
          if (reason === 'input') {
            setAddParticipantText(value);
          }
        }}
        onChange={(_event, selected) => {
          setAddParticipantText('');
          if (selected) {
            onAdd(selected);
          }
        }}
        openOnFocus
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            // ref={addParticipantRef}
            placeholder="参加者を追加"
            inputProps={_.merge(params.inputProps, { style: inputStyle })}
          />
        )}
        style={{ background: '#EEE' }}
      />
      <Box>
        {participants.map(p => (
          <TheBox key={p.id}>
            <Box style={{ marginRight: 'auto' }}>
              <Box display="flex" alignItems="center" padding="2px 0">
                <AccountCircleIcon style={{ marginRight: '4px', color: muiTheme.palette.grey[400] }} />
                <Box>{p.name}</Box>
              </Box>
            </Box>
            <Tooltip title="参加者を外す">
              <DeleteButton size="small" onClick={() => onRemove(p)}>
                <CloseIcon fontSize="small" style={{ color: '#fff' }} />
              </DeleteButton>
            </Tooltip>
          </TheBox>
        ))}
      </Box>
    </>
  );
});

// Participant
export const ParticipantOption = styled.div`
  display: flex;
  align-items: center;
`;

export const ParticipantMainText = styled.div`
  font-size: 0.9rem;
  white-space: nowrap;
`;

export const ParticipantSubText = styled.div`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
`;

export const ParticipantIcon = styled(AccountCircleIcon)`
  width: 15px;
  height: 18px;
  display: block;
  margin-right: 10px;
`;

const TheBox = styled(Box)`
  display: flex;
  align-items: center;
  margin: 4px 0;
  color: ${muiTheme.palette.primary.main};
  p {
    font-size: 12px;
  }
`;

const DeleteButton = styled(IconButton)`
  height: 15px;
  margin: -1px 0 0 8px;
  padding: 2px;
  background-color: ${muiTheme.palette.primary.main};
  color: ${muiTheme.palette.primary.light};

  .MuiSvgIcon-fontSizeSmall {
    height: 11px;
    font-size: 11px;
    line-height: 1;
  }
`;

export default ParticipantInput;
